import { useState } from "react";

export function useGlobalSearch() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [initialQuery, setInitialQuery] = useState("");

  /** Also bound directly as a click handler (dock), so non-string args are ignored. */
  const openSearch = (query?: unknown) => {
    setInitialQuery(typeof query === "string" ? query.trim() : "");
    setIsSearchOpen(true);
  };
  const closeSearch = () => setIsSearchOpen(false);

  return {
    isSearchOpen,
    initialQuery,
    openSearch,
    closeSearch,
  };
}
